import { styled } from '@linaria/react';

import Aside from '@/components/Aside';
import Paragraph from '@/components/Paragraph';
import TextLink from '@/components/Link/TextLink';
import InlineCode from '@/components/InlineCode';

function AnimationTimelineUnsupported() {
  return (
    <Wrapper
      type="warning"
      title={
        <>
          Your browser doesn’t support <code>animation-timeline</code>
          .
        </>
      }
    >
      <Paragraph>
        This code uses the new <code>animation-timeline</code>{' '}
        property, and unfortunately, this property is not yet
        available in your browser.
      </Paragraph>
      <Paragraph>
        To demonstrate the new API, I’ve added a polyfill to the
        playgrounds on this page. The polyfill isn’t perfect, however,
        and not all of the playgrounds on this page work correctly.
      </Paragraph>
      <Paragraph>
        If you’re using Firefox, you can enable scroll-driven
        animations by toggling the{' '}
        <InlineCode>
          layout.css.scroll-driven-animations.enabled
        </InlineCode>{' '}
        flag in <InlineCode>about:config</InlineCode>. You can{' '}
        <TextLink href="https://developer.mozilla.org/en-US/docs/Mozilla/Firefox/Experimental_features#scroll-driven_animations">
          learn more on MDN
        </TextLink>
        .
      </Paragraph>
    </Wrapper>
  );
}

const Wrapper = styled(Aside)`
  @supports (animation-timeline: view()) {
    display: none;
  }
`;

export default AnimationTimelineUnsupported;
